import { getInitialsFromName } from '../../views/portal/utils/format.js'
import './portal-avatar.css'

export interface PortalAvatarProps {
    /** Full name (used to derive initials fallback) */
    name: string
    /** Image URL, null/undefined for initials fallback */
    avatarUrl?: string | null
    /** Preset size variant */
    size?: 'sm' | 'md' | 'lg'
    /** Custom pixel size (overrides variant) */
    px?: number
    /** Optional CSS class for additional styling */
    className?: string
}

export const PortalAvatar = ({
    name,
    avatarUrl,
    size = 'md',
    px,
    className,
}: PortalAvatarProps) => {
    const sizeClass = size !== 'md' ? `portal-avatar--${size}` : ''
    const classes = ['portal-avatar', sizeClass, className].filter(Boolean).join(' ')

    const style = px ? { width: px, height: px, fontSize: Math.round(px * 0.35) } : undefined

    return (
        <div className={classes} style={style}>
            {avatarUrl ? (
                <img src={avatarUrl} alt="" className="portal-avatar__img" />
            ) : (
                getInitialsFromName(name)
            )}
        </div>
    )
}
